<template lang="pug">
#GenoLabs.labs.wrapper.app-page(:ref="component" data-view :class="primaryTabs == 'maps' ? 'absolute' : 'relative'" :user="user && user.username ? user.username : 'unknown'")
  section.el-drawer__body.page(:class="'labs'" :visible.sync="show" :wrapperClosable="false" :closeOnPressEscape="false" :direction="direction" :modal="false" :size="'100%'" :appendToBody="false" :showClose="false" :destroyOnClose="true" v-on:close="closeDrawer" v-on:open="clear" )
    //social(:saveReady="saveReady && !embed" :component="component" :url="shareUrl")
    div#header() Genoplot Labs
      sub.header &nbsp;Experimental Features
    .results(:class="'expanded'")
      el-tabs.tabclass(:class="primaryTabs" :value="primaryTabs" type="border-card" :stretch="false" :beforeLeave="switchTab")
        el-tab-pane.maps(label="Similarity Maps" name="maps")
          .features(v-if="primaryTabs == 'maps'")
            selections()
        el-tab-pane(label="23andMe" name="23andMe" )
          .features.labs(v-if="primaryTabs == '23andMe'")
            .featureset
              label.feature DNA Relatives Data
              label.button.btn.btn-round.btn-info.feature(type="info" round="" size="md")  Load File
                input( ref="file" @change="loadFile($event)" hidden type="file" accept=".csv,.txt")
              label#andMeHelp(@click="showArticle(6100381)"  v-tooltip="'click for help on loading your 23andMe file'") ?
            el-collapse( v-model="activeNames" @change="handleChange" )
              el-collapse-item( name="1" id="haplopane" class="Haplogroups" )
                template(slot="title") Paternal Haplogroups
                  i(class="header-icon fas fa-braille" )
                .chart 
                  #maplegend-wrapper(v-if="sunOptions && sunOptions.series && sunOptions.series.data && sunOptions.series.data.length > 0")
                    #maplegend(@contextmenu.prevent="$refs.sunburstmenu.open" v-tooltip="{offset: '30,-5',  autoHide: true, classes: ['noarrow'], content:'Right-click for export options<br>'}")
                      div.legend(v-for="(haplo,i) in haplos")
                        div.legend-item()
                          div.series-color(:style="`background-color: ${colors[i % colors.length]}`"  )
                          div.series
                            span.haplo Haplogroup &nbsp;
                            span.name {{haplo.name}}
                          div.series-value {{(haplo.value.toFixed(2).substr(-2) == '00' ? haplo.value.toFixed(0) : haplo.value.toFixed(1)) + ' %'}}
                  #sunburst-wrapper.chartwrapper(v-if="sunOptions && sunOptions.series && sunOptions.series.data && sunOptions.series.data.length > 0" style="height: 492px" )
                    .labprofile(:class="''"  click=""  vtooltip="{ content: 'Click to toggle TreeMap', classes: ['oracles']}")
                    div#sunburst(v-tooltip="{offset: '-85,-20',  autoHide: true, classes: ['export', 'noarrow'], content:'Right-click for export options<br>'}" )
                      .menu(@contextmenu.prevent="$refs.sunburstmenu.open")
                        v-chart(:options="sunOptions" :initOptions="initOptions"  ref="echart-sunburst" @contextmenua.prevent="$refs.sunburstmenu.open" :renderer="'svg'" autoresize=true)
              el-collapse-item( name="2" class="LastNames")
                template(slot="title") Reported Last Names
                  i(class="header-icon fas fa-signature" )
                .chart 
                  #gridname(v-if="primaryTabs == '23andMe' && namedata && namedata.length > 0" contextmenu.prevent="$refs.sheetmenu.open($event, 'gridname')")
                    ag-grid-vue#gridtable(v-dragscroll=false  class="ag-theme-alpine" suppress-horizontal-scroll=false enable-cell-text-selection="false" animate-rows=true :gridOptions="gridOptions"  row-selection="multiple" rowDeselection="true" rowMultiSelectWithClick="false" :columnDefs="columnDefs" :rowData="rowData" domLayout="autoHeight")
              el-collapse-item( name="3" class="Grandparents" )
                template(slot="title") Reported Grandparents' Locations
                  i(class="header-icon fas fa-globe" )
                .chart  
                  #gridcountry(v-if="primaryTabs == '23andMe' && countrydata && countrydata.length > 0" contextmenu.prevent="$refs.sheetmenu.open($event, 'gridcountry')")
                    ag-grid-vue#gridtable(v-dragscroll=false  class="ag-theme-alpine" suppress-horizontal-scroll=false enable-cell-text-selection="false" animate-rows=true :gridOptions="gridOptions2"  row-selection="multiple" rowDeselection="true" rowMultiSelectWithClick="false" :columnDefs="columnDefs2" :rowData="rowData2" domLayout="autoHeight")
        el-tab-pane(label="FTDNA" :disabled="false" name="FTDNA")
          .features.labs(v-if="primaryTabs == 'FTDNA'")
            .featureset
              label.feature DNA Relatives Data
              label.button.btn.btn-round.btn-info.feature(type="info" round="" size="md")  Load File
                input( ref="file" @change="loadFile($event)" hidden type="file" accept=".csv,.txt")
              label#andMeHelp(@click="showArticle(6106742)"  v-tooltip="'click for help on loading your FTDNA file'") ?
            el-collapse( v-model="activeNames" @change="handleChange" )
              el-collapse-item( name="1" id="haplopane" class="Haplogroups" )
                template(slot="title") Paternal Haplogroups
                  i(class="header-icon fas fa-braille" )
                .chart 
                  #maplegend-wrapper(v-if="sunOptions && sunOptions.series && sunOptions.series.data && sunOptions.series.data.length > 0")
                    #maplegend(@contextmenu.prevent="$refs.sunburstmenu.open" v-tooltip="'Right-click for export options<br>'")
                      div.legend(v-for="(haplo,i) in haplos")
                        div.legend-item()
                          div.series-color(:style="`background-color: ${colors[i % colors.length]}`"  )
                          div.series
                            span.haplo Haplogroup &nbsp;
                            span.name {{haplo.name}}
                          div.series-value {{(haplo.value.toFixed(2).substr(-2) == '00' ? haplo.value.toFixed(0) : haplo.value.toFixed(1)) + ' %'}}
                  #sunburst-wrapper.chartwrapper(v-if="sunOptions && sunOptions.series && sunOptions.series.data && sunOptions.series.data.length > 0" style="height: 492px" )
                    .labprofile(:class="''"  click=""  vtooltip="{ content: 'Click to toggle TreeMap', classes: ['oracles']}")
                    div#sunburst(v-tooltip="{offset: '-10,-70',  classes: ['export'], content:'Right-click for export options<br>'}" )
                      .menu(@contextmenu.prevent="$refs.sunburstmenu.open")
                        v-chart(:options="sunOptions" :initOptions="initOptions"  ref="echart-sunburst" @contextmenua.prevent="$refs.sunburstmenu.open" :renderer="'svg'" autoresize=true)
              el-collapse-item( name="2" class="LastNames")
                template(slot="title") Reported Last Names
                  i(class="header-icon fas fa-signature" )
                .chart 
                  #gridname(v-if="primaryTabs == 'FTDNA' && namedata && namedata.length > 0" @contextmenu.prevent="$refs.sheetmenu.open($event, 'gridname')")
                    ag-grid-vue#gridtable(v-dragscroll=false  class="ag-theme-alpine" suppress-horizontal-scroll=false enable-cell-text-selection="false" animate-rows=true :gridOptions="gridOptions"  row-selection="multiple" rowDeselection="true" rowMultiSelectWithClick="false" :columnDefs="columnDefs" :rowData="rowData" domLayout="autoHeight")
              //el-collapse-item( name="3" class="Grandparents" )
                template(slot="title") Reported Grandparents' Locations
                  i(class="header-icon fas fa-globe" )
                .chart  
                  #gridcountry(v-if="primaryTabs == 'FTDNA' && countrydata && countrydata.length > 0" @contextmenu.prevent="$refs.sheetmenu.open($event, 'gridcountry')")
                    ag-grid-vue#gridtable(v-dragscroll=false  class="ag-theme-alpine" suppress-horizontal-scroll=false enable-cell-text-selection="false" animate-rows=true :gridOptions="gridOptions2"  row-selection="multiple" rowDeselection="true" rowMultiSelectWithClick="false" :columnDefs="columnDefs2" :rowData="rowData2" domLayout="autoHeight")
        el-tab-pane(label="MyHeritage" :disabled="true" )
        el-tab-pane(label="AncestryDNA" :disabled="true" )
    vue-context( ref="sunburstmenu" )
      li
        a( href="#" @click.prevent="copySampleToClip('text')") Copy data to Clipboard
      li
        a( href="#" @click.prevent="copySampleToClip('html')") Copy data to Clipboard (HTML)
      li
        a( href="#" @click.prevent="copySampleToClipBB()") Copy data (BBCode formatted)
      li
        a( href="#" @click.prevent="uploadImage('haplopane', 'svg')") Get sharable link for uploaded image
    vue-context( ref="sheetmenu" v-slot="{data}" )
      li
        a( href="#" @click.prevent="copyToClip('text', data)") Copy table to Clipboard
      li
        a( href="#" @click.prevent="copyToClip('html', data)") Copy table to Clipboard (HTML)
      li
        a( href="#" @click.prevent="copyToClipForum(data)") Copy table (BBCode formatted)
      li
        a( href="#" @click.prevent="uploadImage(data, 'svg')") Get sharable link for uploaded image
</template>
<script>
  import {
      mapState
  } from 'vuex'
  const Social = () => import("@/components/Social.vue");
  const Selections = () => import("@/components/selections/selections.vue");
  import axios from 'axios'
  import copy from 'copy-html-to-clipboard';
  import Table from 'table-builder'
  import tablecss from '@/table.js'
  import "../plugins/ag-grid-community/dist/styles/ag-grid.css";
  import "../plugins/ag-grid-community/dist/styles/ag-theme-alpine.css";
  import "../plugins/ag-grid-community/dist/styles/ag-theme-alpine-dark-geno.css";
  import {
      Button
  } from '@/components'
  import domtoimage from 'dom-to-image-improved';
  import 'echarts/lib/chart/sunburst'
  import 'echarts/lib/chart/treemap'
  import 'echarts/lib/component/tooltip'
  import 'echarts/lib/component/legend'
  import 'echarts/lib/component/title'
  import {
      Collapse,
      CollapseItem
  } from 'element-ui'
  import {
      AgGridVue
  } from '../plugins/ag-grid-vue'
  import updateGenoLabsMutation from "@/graphql/updateGenoLabsMutation";
  import getLabsFeatureQuery from "@/graphql/getLabsFeatureQuery.js";
  import getLabsDataQuery from "@/graphql/getLabsDataQuery.js";
  import getFilebaseSignatureQuery from "@/graphql/getFilebaseSignatureQuery"
  const countries = require('@/data/countries.json')
  export default {
      name: 'GenoLabs',
      bodyClass: 'app-page,labs,selections-container,nmonte-container',
      props: {
          showlab: {
              type: Boolean,
              default: true,
          }
      },
      data() {
          return {
              empty: null,
              unchanged: null,
              runMonte: null,
              showSelections: null,
              collapsed: null,
              introData: null,
              empty: null,
              shareUrl: {},
              gridReady: false,
              embed: false,
              component: 'labs',
              sunburstSeries: [],
              countrydata: '',
              namedata: '',
              direction: 'rtl',
              content: "Consistent with real life: in line with the process and logic of real life, and comply with languages and habits that the users are used to; Consistent within interface: all elements should be consistent, such as: design style, icons and texts, position of elements, etc",
              source: null,
              activeNames: [],
              initOptions: {
                  renderer: 'svg',
              },
              colors: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a',
                  '#6e7074',
                  '#546570', '#c4ccd3'
              ],
              sunOptions2: {
                  tooltip: {
                      trigger: 'item',
                      formatter: `Haplogroup&nbsp;{b}&nbsp;<br>&nbsp;<b>{c} %</b>`,
                  },
                  itemStyle: {
                      emphasis: {
                          color: 'brown'
                      },
                      highlight: {
                          color: 'brown'
                      },
                      downplay: {
                          color: 'gray'
                      }
                  },
                  label: {
                      formatter: function(data) {
                          return data.data.value >= 1 ? `${data.data.name} ${data.data.value} % ` : ''
                      }
                  },
                  series: {
                      type: 'treemap',
                      data: this.sunburstSeries,
                      animationDurationUpdate: 1000,
                      universalTransition: true,
                      avoidLabelOverlap: true,
                  }
              },
              sunOptions: {
                  tooltip: {
                      trigger: 'item',
                      formatter: `Haplogroup&nbsp;{b}&nbsp;<br>&nbsp;<b>{c} %</b>`,
                  },
                  itemStyle: {
                      emphasis: {
                          color: 'brown'
                      },
                      highlight: {
                          color: 'brown'
                      },
                      downplay: {
                          color: 'gray'
                      }
                  },
                  label: {
                      formatter: function(data) {
                          return data.data.value >= 1 ? `${data.data.name} ${data.data.value} % ` : ''
                      }
                  },
                  series: {
                      animationDurationUpdate: 1000,
                      type: 'sunburst',
                      data: this.sunburstSeries,
                      highlightPolicy: 'self',
                      radius: [0, '90%'],
                      avoidLabelOverlap: true,
                      levels: [{}, {
                          r0: '20%',
                          r: '55%',
                          highlightPolicy: 'descendant',
                          itemStyle: {
                              borderWidth: 2,
                              opacity: 1,
                          },
                          label: {
                              show: true,
                              minAngle: 10,
                              fontSize: 15,
                              borderRadius: 9,
                              textShadowColor: '#333333',
                              textShadowBlur: 3,
                              textShadowOffsetX: 2,
                              textShadowOffsetY: 1,
                              padding: [7, 9],
                              rotate: 0,
                              color: 'white'
                          }
                      }, {
                          r0: '55%',
                          r: '72%',
                          label: {
                              position: 'outside',
                              show: true,
                              minAngle: 6,
                              padding: [30, 20],
                              borderRadius: 0,
                              fontSize: 12,
                              silent: true,
                              itemStyle: {
                                  borderWidth: 2,
                              },
                              color: '#444',
                              rotate: 0,
                              distance: 20
                          }
                      }, {
                          r0: '72%',
                          r: '80%',
                          label: {
                              position: 'outside',
                              show: false,
                              minAngle: 5,
                              silent: false,
                              itemStyle: {
                                  borderWidth: 2,
                              }
                          }
                      }]
                  }
              },
          }
      },
      beforeCreate: async function() {},
      created() {
          this.$eventBus.$on('appEvents', this.appEvents)
          this.toggleTheme()
          this.initiated = false;
          this.maintenance = false;
          let theme = localStorage.getItem('genoTheme');
          if (theme && theme == 'dark') {
              this.theme = true;
          } else {
              this.theme = false;
          }
      },
      beforeMount() {
          let w = this;
          w.gridReady = false;
          this.gridOptions = {
              scrollbarWidth: 0,
              suppressHorizontalScroll: true,
              enableBrowserTooltips: false,
              animateRows: false,
              pagination: true,
              paginationPageSize: 20,
              floatingFilter: false,
              sortingOrder: ['desc', 'asc'],
              onFirstDataRendered: function(params) {},
              onModelUpdated: function(params) {
                  setTimeout(function() {
                      params.api.sizeColumnsToFit();
                  }, 100)
              },
              onGridReady: function(params) {
                  setTimeout(function() {
                      params.api.sizeColumnsToFit();
                      w.gridReady = true;
                  }, 0)
                  window.addEventListener('resize', function() {
                      setTimeout(function() {
                          params.api.sizeColumnsToFit();
                      }, 500)
                  })
              }
          }
          this.gridOptions2 = {
              scrollbarWidth: 0,
              suppressHorizontalScroll: true,
              enableBrowserTooltips: false,
              animateRows: false,
              pagination: true,
              paginationPageSize: 20,
              floatingFilter: false,
              sortingOrder: ['desc', 'asc'],
              onFirstDataRendered: function(params) {},
              onModelUpdated: function(params) {
                  setTimeout(function() {
                      params.api.sizeColumnsToFit();
                  }, 100)
              },
              onGridReady: function(params) {
                  setTimeout(function() {
                      params.api.sizeColumnsToFit();
                  }, 0)
                  window.addEventListener('resize', function() {
                      setTimeout(function() {
                          params.api.sizeColumnsToFit();
                      }, 500)
                  })
              }
          }
      },
      mounted() {
          let w = this;
          if (w[this.primaryTabs]) w[this.primaryTabs]()
      },
      beforeDestroy() {
          this.$store.commit('change', {
              showlab: false
          })
          this.$store.commit('change', {
              spinner: false
          })
          this.$eventBus.$off('appEvents', this.appEvents)
      },
      methods: {
          "23andMe": async function() {
              this.clear()
          },
          FTDNA: async function() {
              this.clear()
          },
          recordEvent: function(evt, meta) {
              let ignore = []
              meta.component = this.component;
              this.$gtag.event(evt, meta);
              if (ignore.indexOf(evt.toLowerCase()) < 0 && this.$genericevent) this.$genericevent.trackEvent(evt,
                  meta);
          },
          appEvents: function(info) {
              if (typeof(info) === 'object' && this.primaryTabs != 'maps' && (info.component === 'labs' || info.component === 'global')) {
                  if (this[info.exec]) {
                      this[info.exec](info.params)
                  }
              }
          },
          mfaValidated: async function(evt) {
              let w = this;
              if (evt.action && evt.mfapassed == true && (evt.token || evt.code)) {
                  w[evt.action]({
                      code: evt.code,
                      token: evt.token,
                      mfapassed: true
                  })
              }
          },
          getInitialColorMode(value) {
              const persistedColorPreference = value == 'system' ? false : value
              const hasPersistedPreference = typeof persistedColorPreference === 'string';
              if (hasPersistedPreference) {
                  this.setColors(persistedColorPreference)
                  return persistedColorPreference;
              }
              const mql = window.matchMedia('(prefers-color-scheme: dark)');
              const hasMediaQueryPreference = typeof mql.matches === 'boolean';
              if (hasMediaQueryPreference) {
                  this.setColors(mql.matches ? 'dark' : 'light')
                  return mql.matches ? 'dark' : 'light';
              }
              this.setColors('light')
              return 'light';
          },
          setColors(value) {
              if (value == 'dark') {
                  document.documentElement.style.setProperty('--bg-color', '#181818');
                  document.documentElement.style.setProperty('--color', '#dfdfdf');
              } else {
                  document.documentElement.style.setProperty('--bg-color', '#f2f2f2');
                  document.documentElement.style.setProperty('--color', '#444444');
              }
          },
          toggleTheme() {
              this.currentShare = false;
              let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ?
                  this
                  .slider.theme.value.toLowerCase() : 'system'
              let genoTheme = this.getInitialColorMode(value)
              localStorage.setItem("genoTheme", genoTheme);
              let wn = document.getElementById('discussionframe');
              if (wn && wn.contentWindow) {
                  wn = wn.contentWindow
                  if (value == 'system') {
                      wn.postMessage({
                          action: 'removeStorage',
                          content: {
                              key: 'genoTheme'
                          },
                          source: 'genoplot.com'
                      }, '*')
                  } else {
                      wn.postMessage({
                          action: 'setStorage',
                          content: {
                              key: 'genoTheme',
                              value: genoTheme
                          },
                          source: 'genoplot.com'
                      }, '*')
                  }
              }
              const el = document.body;
              let sunOptions = this.sunOptions;
              let heatmapColors = this.heatmapColors;
              let levels = sunOptions.series.levels;
              if (el.classList.contains('dark') && genoTheme != 'dark') {
                  el.classList.remove('dark')
                  levels[2].label.color = '#444'
                  this.theme = false
              } else if (genoTheme == 'dark') {
                  el.classList.add('dark')
                  levels[2].label.color = '#f2f2f2'
                  this.theme = true
              }
              if (this.gridOptions && this.gridOptions.api) {
                  this.gridApi = this.gridOptions.api;
                  this.gridApi.refreshCells()
              }
              this.sunOptions = sunOptions;
          },
          switchTab(evt) {
              this.primaryTabs = evt;
              this.namedata = []
              this.countrydata = []
              let getLabsData = ['23andMe', 'FTDNA']
              let sunOptions = JSON.parse(JSON.stringify(this.sunOptions))
              sunOptions.series.data = []
              this.sunOptions = sunOptions
              if (getLabsData.some(x => x == this.primaryTabs)) {
                  this.$nextTick(() => {
                      this.clear();
                  })
              }
          },
          clear: async function(evt) {
              let dataExists = true;
              let w = this;
              w.retries = w.retries ? w.retries + 1 : 0
              let lab = w.primaryTabs
              if (!lab) return;
              if (!evt || !evt.mfapassed) {
                  try {
                      let data = await w.$apollo.query({
                          query: getLabsDataQuery.query,
                          variables: {
                              userid: w.user.username
                          },
                          fetchPolicy: 'network-only'
                      })
                      if (data && data.data && data.data.getLabsData && data.data.getLabsData.length > 0) {
                          let features = data.data.getLabsData.filter(x => x.feature && x.feature.includes(lab))
                          if (features.length > 0) {
                              dataExists = true
                          } else {
                              dataExists = false
                          }
                      } else {
                          dataExists = false;
                      }
                  } catch (err) {
                      dataExists = true
                      console.log(err)
                  }
              }
              if (!dataExists) {
              w.running = false;
              return;
              }
              w.running = true;
              if (dataExists && (!evt || !evt.mfapassed)) {
                  //console.log('MFA needed')
                  this.$eventBus.$emit('appEvents', {
                      exec: 'showModal',
                      component: 'nav',
                      params: {
                          pred: 'verifyToken',
                          token: `token-labs`,
                          modal: 'VerifyMfaModal',
                          exec: {
                              action: 'clear',
                              method: this.mfaValidated
                          },
                      }
                  })
              w.running = false;
                  return;
              }
              let signature = false;
              try {
                  signature = sessionStorage.getItem(`token-labs`) ? JSON.parse(sessionStorage.getItem(
                      `token-labs`)).signed : false;
              } catch (err) {
                  console.log('signature err', err)
              }
              this.source = null
              this.recordEvent(`labs-${lab}`, {
                  'event_category': 'function',
                  'event_label': 'User initiated'
              })
              this.activeNames = []
              if (signature) {
              w.running = true;
                  try {
                      let w = this;
                      let sunOptions = JSON.parse(JSON.stringify(w.sunOptions))
                      let levels = sunOptions.series.levels;
                      let theme = localStorage.getItem('genoTheme');
                      if (theme && theme == 'dark') {
                          this.theme = true;
                          levels[2].label.color = 'white'
                      } else {
                          levels[2].label.color = 'black'
                      }
                      this.sunOptions = sunOptions;
                      let features = ['haplos', 'names', 'countries']
                      let dataResults = {
                          haplosData: [],
                          namesData: [],
                          countriesData: []
                      }
                      let errors = []
                      let dataArray = features.map(async feature => {
                          try {
                              let data = await w.$apollo.query({
                                  query: getLabsFeatureQuery.query,
                                  variables: {
                                      userid: w.user.username,
                                      feature: `${lab}:${feature}`,
                                      component: w.component,
                                      signature: signature
                                  },
                                  fetchPolicy: 'network-only'
                              })
                              if (data && data.data && data.data.getLabFeature && data.data
                                  .getLabFeature
                                  .data) {
                                  dataResults[`${feature}Data`] = JSON.parse(data.data.getLabFeature
                                      .data)
                              }
                          } catch (err) {
                              errors.push(err.message || err)
                          }
                      })
                      let results = await Promise.all(dataArray)
                      if (errors.length) {
                          console.log('errs', w.retries)
                          if (w.retries && w.retries > 1) {
                              w.retries = undefined
                              w.$modal.show('dialog', {
                                  title: 'Error',
                                  text: errors[0],
                                  clickToClose: true,
                                  class: 'warning'
                              })
                              return;
                          } else {
                              w.retries = 1;
                              sessionStorage.removeItem('token-labs')
                              w.clear()
                              return;
                          }
                      }
                      w.retries = undefined
                      if (dataResults.countriesData.length) {
                          this.countrydata = dataResults.countriesData
                          this.activeNames.push("3")
                      }
                      if (dataResults.namesData.length) {
                          this.namedata = dataResults.namesData
                          this.activeNames.unshift("2")
                      }
                      if (dataResults.haplosData.length) {
                          sunOptions.series.data = dataResults.haplosData
                          this.activeNames.unshift("1")
                          sunOptions.tooltip.formatter = function(params) {
                              let name = params.treePathInfo[1].name
                              if (name == params.data.name) {
                                  return `Haplogroup ${params.data.name}<br/><b>${params.data.value.toFixed(2).substr(-2) == '00' ? params.data.value.toFixed(0) : params.data.value.toFixed(1)}</b> %`
                              } else {
                                  return `Haplogroup ${name}-${params.data.name}<br/><b>${params.data.value.toFixed(2).substr(-2) == '00' ? params.data.value.toFixed(0) : params.data.value.toFixed(1)}</b> %`
                              }
                          }
                          sunOptions.label.formatter = function(data) {
                              let name = data.treePathInfo[1].name
                              if (name == data.data.name) {
                                  return data.data.value >= 5 ?
                                      `${data.data.name} ${data.data.value.toFixed(2).substr(-2) == '00' ? data.data.value.toFixed(0) : data.data.value.toFixed(1)} % ` :
                                      ''
                              } else {
                                  return data.data.value >= 5 ?
                                      `${name}-${data.data.name} ${data.data.value.toFixed(2).substr(-2) == '00' ? data.data.value.toFixed(0) : data.data.value.toFixed(1)} % ` :
                                      ''
                              }
                          }
                          w.sunOptions = sunOptions
                      }
                      w.spinner = false;
                  } catch (err) {
                      console.log(err)
                      w.spinner = false;
                  }
              } else {
                  console.log('No signature for labs query')
                  w.running = false;
              }
          },
          showArticle(evt) {
              this.$genericevent.showArticle(evt);
          },
          uploadImage: async function(el, type) {
              let w = this;
              console.log('started')
              w.$store.commit('change', {
                  spinner: true
              })
              setTimeout(() => {
                  delete w.markerArea
                  w.editedImageUrl = undefined
                  w.editedImageUrl2 = undefined
                  w.exporting = true;
                  let element = el
                  try {
                      let image = type;
                      let contentType = "image/svg+xml"
                      let fileType = 'image'
                      let name = w.alias ? w.alias : w.user.username;
                      let path = `${name}/${element}-${Date.now().toString(16)}`
                      let sigparams = {
                          filePath: path,
                          fileType: fileType,
                          contentType: contentType
                      }
                      let node = document.getElementById(el);
                      let style = el === 'table' ? {
                          marginTop: '-50px',
                          padding: 0
                      } : el === 'barchart' ? {
                          'margin': 0,
                          'width': '100%',
                          marginTop: '-10px',
                          padding: 'unset'
                      } : el === 'apex-heatmap' ? {
                          marginTop: '-25',
                          padding: 0
                      } : el === 'map' ? {
                          marginTop: '50px',
                          padding: 0
                      } : el === 'haplopane' ? {
                          margin: 0,
                          padding: 0,
                          paddingLeft: '30px',
                          paddingTop: '10px'
                      } : el === 'grid' ? {
                          margin: 0,
                          padding: 0,
                          paddingLeft: '50px',
                      } : {
                          margin: 0,
                          padding: 0
                      }
                      domtoimage.toSvg(node, {
                              bgcolor: this.theme && el === 'table' ? '#14191f' : this.theme ? 'black' :
                                  'white',
                              style: style
                          })
                          .then(async function(blob) {
                              let prefix = 'https://shared.genoplot.com/file/genofiles'
                              let svg = blob.replace(/data\:image\/svg\+xml\;charset\=utf-8\,/, '')
                                  .replace(/\%0A/g, '')
                              let style = ''
                              if (element == 'haplopane') {
                                  let string =
                                      '* { pointer-events: none !important;} #maplegenda { margin-left: -5px !important;} .header-icon { display: none !important;}'
                                  style = `<style>${string}</style>`
                              } else if (element === 'chart') {
                                  let background = w.theme ? '#000000b5' : '#ffffffb5'
                                  let title = w.theme ? 'black' : 'white'
                                  let string =
                                      `#maplegend-wrapper { background: ${background} !important;} `
                                  string = el === 'sunburst' ? string +
                                      ` .title-container .title {background: ${title} !important;}` :
                                      string
                                  style = `<style>${string}</style>`
                              } else {
                                  if (w.theme) {
                                      style =
                                          "<style>* { pointer-events: none;}foreignObject, foreignObject > *, foreignObject .switchChartType { background: #000000 !important;}</style>"
                                  } else {
                                      style =
                                          "<style>* { pointer-events: none !important;} .ag-header-cell { min-width: 200px !important}.ag-header-group-cell-label, .ag-header-cell-label { text-overflow: unset !important} .ag-paging-panel { display: none !important;} span.ag-header-cell-text { min-width: 200px !important;text-overflow: unset !important;} </style>"
                                  }
                              }
                              svg = svg.replace(/\>\<foreignObject/, `>${style}<foreignObject`)
                              var svgBlob = new Blob([svg], {
                                  type: "image/svg+xml;charset=utf-8"
                              });
                              var svgUrl = URL.createObjectURL(svgBlob);
                              w.putImage(svg, prefix, path, sigparams, element)
                          }).catch(function(err) {
                              console.log(err);
                              w.$store.commit('change', {
                                  spinner: false
                              })
                              w.exporting = false;

                          })
                  } catch (err) {
                      w.spinner = false
                      w.exporting = false;
                      console.log(err);
                  }
              }, 0)
          },
          putImage: async function(svg, prefix, path, sigparams, element) {
              let w = this;
              w.spinner = true;
              let data = await w.$apollo.query({
                  query: getFilebaseSignatureQuery,
                  variables: {
                      params: JSON.stringify(sigparams)
                  },
                  fetchPolicy: 'network-only'
              })
              if (data && data.data && data.data.getFilebaseSignature && data.data.getFilebaseSignature.result) {
                  let result = JSON.parse(data.data.getFilebaseSignature.result);
                  let signedUrl = result.url;
                  let options = {
                      headers: {
                          'Content-Type': sigparams.contentType,
                          'Content-Encoding': 'gzip',
                          'Cache-Control': 'max-age=86400'
                      }
                  }
                  const operation = w.$retry.operation({
                      retries: 3,
                      factor: 2,
                      minTimeout: 125,
                      maxTimeout: 1000,
                      randomize: false,
                  });
                  operation.attempt(async (currentAttempt) => {
                      w.spinner = true;
                      console.log('sending request: ', currentAttempt, ' attempt');

                      try {
                          axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(svg)), options)
                              .then(function(result) {
                                  w.spinner = false
                                  w.exporting = false
                                  w.currentShare = false;
                                  console.log(`${prefix}/${path}`)
                                  delete w.markerArea
                                  if (element !== 'savedImage') {
                                      w.showShared(`${prefix}/${path}`, element)
                                  } else {
                                      return `${prefix}/${path}`
                                  }
                              })
                              .catch(function(err) {
                                  console.log(err);
                                  if (operation.retry(err)) {
                                      return;
                                  }
                                  w.spinner = false
                                  w.exporting = false;
                                  console.log(err);
                                  w.$eventBus.$emit('appEvents', {
                                      exec: 'show',
                                      component: 'nav',
                                      params: {
                                          title: "Error",
                                          text: "unable to upload Image",
                                          class: 'warning'
                                      }
                                  })
                              });
                      } catch (e) {
                          if (operation.retry(e)) {
                              return;
                          }
                      }
                  })
              } else {
                  console.log(data);
                  w.spinner = false
                  w.exporting = false;
                  w.$eventBus.$emit('appEvents', {
                      exec: 'show',
                      component: 'nav',
                      params: {
                          title: "Error",
                          text: "unable to upload Image",
                          class: 'warning'
                      }
                  })
              }
          },
          showShared: async function(url, element) {
              let w = this;
              let buttons = [{
                  title: "Copy URL",
                  handler: (i, event) => {
                      copy(url)
                      document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                  }
              }, {
                  title: "Copy URL (BBCode)",
                  handler: (i, event) => {
                      let bburl = `[URL="${url}"][IMG]${url}[/IMG][/URL]`
                      copy(bburl)
                      document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                  }
              }, {
                  title: 'Close',
                  default: true
              }]
              w.$modal.show('dialog', {
                  title: 'Link to sharable image',
                  text: `You can now share an image of this ${element} from this <a style='color:steelblue;' target='_blank' href=${url}>link</a>`,
                  buttons: buttons,
                  clickToClose: false,
                  beforeClosed: function(event) {
                      console.log('closing', event)
                  }
              })
          },
          handleChange() {},
          copyToClip(type, el) {
              var headers = {}
              var w = this;
              headers[el == 'gridname' ? 'name' : 'country'] = el == 'gridname' ? 'SURNAME' : 'COUNTRY'
              headers.count = 'COUNT'
              var tabledata = []
              let gridApi = el == 'gridname' ? w.gridOptions.api : w.gridOptions2.api
              gridApi.getRenderedNodes().map((row) => {
                  let name = row.data
                  var obj = {};
                  obj[el == 'gridname' ? 'name' : 'country'] = el == 'gridname' ? name.name : name.country
                  obj.count = name.count
                  tabledata.push(obj)
              })
              var copyhtml = new Table({
                  'class': 'tableHTML'
              }).setHeaders(headers).setData(tabledata).render()
              copyhtml = juice.inlineContent(copyhtml, tablecss)
              let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
              if (type === 'text') {
                  copy(copytext, {
                      asHtml: false,
                  });
              } else {
                  copy(copyhtml, {
                      asHtml: true,
                  });
              }
          },
          copyToClipForum(el) {
              var headers = {}
              var w = this;
              headers[el == 'gridname' ? 'name' : 'country'] = el == 'gridname' ? 'SURNAME' : 'COUNTRY'
              headers.count = 'COUNT'
              var tabledata = []
              let gridApi = el == 'gridname' ? w.gridOptions.api : w.gridOptions2.api
              gridApi.getRenderedNodes().map((row) => {
                  //w.rowData.forEach(name => {
                  let name = row.data
                  var obj = {};
                  obj[el == 'gridname' ? 'name' : 'country'] = el == 'gridname' ? name.name : name.country
                  obj.count = name.count
                  tabledata.push(obj)
              })
              var copyhtml = new Table({
                  'class': 'tableHTML'
              }).setHeaders(headers).setData(tabledata).render()
              copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
              var replace = new RegExp(' class=.*?]', 'g')
              copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, " ► ")
              copyhtml = `[size=1]${copyhtml}[/size]`
              //if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/g25/?share=${w.currentShare.path + '#' + w.currentShare.theme}"]GenoPlot[/URL]\n` + copyhtml
              copy(copyhtml, {
                  asHtml: false,
              });
          },
          copySampleToClip(type) {
              var headers = {}
              var w = this;
              w.haplos.forEach(haplo => {
                  headers[haplo.name] = haplo.name
              })
              console.log(headers);
              var tabledata = []
              let obj = {}
              w.haplos.forEach((haplo, i) => {
                  obj[haplo.name] = (haplo.value.toFixed(1).substr(-1) == '0' ? haplo.value : haplo.value
                      .toFixed(1)) + ' %'
              })
              tabledata.push(obj);
              var copyhtml = new Table({
                  'class': 'tableHTML'
              }).setHeaders(headers).setData(tabledata).render()
              let copytext = this.$yaml.stringify(obj, 2).replace(/-\n/g, '\n').replace(/'/g, '')
              copyhtml = juice.inlineContent(copyhtml, tablecss)
              if (type === 'text') {
                  copy(copytext, {
                      asHtml: false,
                  });
              } else {
                  copy(copyhtml, {
                      asHtml: true,
                  });
              }
          },
          copySampleToClipBB() {
              var headers = {}
              var w = this;
              headers.key = ''
              headers.group = ''
              headers.count = ''
              var tabledata = []
              tabledata.push({
                  key: 'Paternal Haplogroups',
                  group: '',
                  count: ''
              })
              w.haplos.forEach((haplo, i) => {
                  let obj = {}
                  obj.key = i === 0 ? 'Groups:' : ''
                  obj.group = haplo.name
                  obj.count = (haplo.value.toFixed(1).substr(-1) == '0' ? haplo.value : haplo.value.toFixed(
                      1)) + ' %'
                  tabledata.push(obj);
              })
              var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
              var replaceHeaders = new RegExp('<thead>(.*?)</thead>')
              copyhtml = copyhtml.replace(replaceHeaders, '')
              copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
              var replace = new RegExp(' class=.*?]', 'g')
              copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']')
              let size = tabledata.length > 6 ? 1 : 1
              copyhtml = `[size=${size}]${copyhtml}[/size]`
              copy(copyhtml, {
                  asHtml: false,
              });
          },
          rawData(evt) {},
          loadFile: async function(event) {
              let w = this;
              let feature = w.primaryTabs
              if (!feature) return;
              let fileInputElement = w.$refs.file;
              const {
                  files
              } = event.target
              if (files && files[0]) {
                  const reader = new FileReader();
                  reader.onload = async (event) => {
                      try {
                          w.spinner = true
                          let results = w[`read${feature}File`](event);
                          let data = results[0] || []
                          let surnames = results[1] || []
                          let countries = results[2] || []
                          let sunOptions = JSON.parse(JSON.stringify(w.sunOptions))
                          sunOptions.series.data = data
                          let haplodata = {
                              userid: w.user.username,
                              feature: `${feature}:haplos`,
                              date: Date.now(),
                              data: JSON.stringify(data)
                          }
                          let namedata = {
                              userid: w.user.username,
                              feature: `${feature}:names`,
                              date: Date.now(),
                              data: JSON.stringify(surnames)
                          }
                          let countrydata = {
                              userid: w.user.username,
                              feature: `${feature}:countries`,
                              date: Date.now(),
                              data: JSON.stringify(countries)
                          }
                          let GenoLabHaplos = this.$apollo.mutate({
                              mutation: updateGenoLabsMutation,
                              variables: {
                                  params: haplodata
                              }
                          })
                          let GenoLabNames = this.$apollo.mutate({
                              mutation: updateGenoLabsMutation,
                              variables: {
                                  params: namedata
                              }
                          })
                          let GenoLabCountries = this.$apollo.mutate({
                              mutation: updateGenoLabsMutation,
                              variables: {
                                  params: countrydata
                              }
                          })
                          let updateGenoLabCountries = await (GenoLabCountries);
                          w.countrydata = JSON.parse(countrydata.data)
                          let updateGenoLabNames = await (GenoLabNames);
                          w.namedata = JSON.parse(namedata.data)
                          let updateGenoLabHaplos = await GenoLabHaplos
                          sunOptions.tooltip.formatter = function(params) {
                              let name = params.treePathInfo[1].name
                              if (name == params.data.name) {
                                  return `Haplogroup ${params.data.name}<br/><b>${params.data.value.toFixed(2).substr(-2) == '00' ? params.data.value.toFixed(0) : params.data.value.toFixed(1)}</b> %`
                              } else {
                                  return `Haplogroup ${name}-${params.data.name}<br/><b>${params.data.value.toFixed(2).substr(-2) == '00' ? params.data.value.toFixed(0) : params.data.value.toFixed(1)}</b> %`
                              }
                          }
                          sunOptions.label.formatter = function(data) {
                              let name = data.treePathInfo[1].name
                              if (name == data.data.name) {
                                  return data.data.value >= 5 ?
                                      `${data.data.name} ${data.data.value.toFixed(2).substr(-2) == '00' ? data.data.value.toFixed(0) : data.data.value.toFixed(1)} % ` :
                                      ''
                              } else {
                                  return data.data.value >= 5 ?
                                      `${name}-${data.data.name} ${data.data.value.toFixed(2).substr(-2) == '00' ? data.data.value.toFixed(0) : data.data.value.toFixed(1)} % ` :
                                      ''
                              }
                          }
                          /*
                          sunOptions.tooltip.formatter = function (params) {
                                return `Haplogroup ${params.data.name}<br/><b>${params.data.value.toFixed(1).substr(-1) == '0' ? params.data.value : params.data.value.toFixed(1)}</b> %` 
                                }
                          sunOptions.label.formatter = function(data) {
                                    return data.data.value >= 1 ? `${data.data.name} ${data.data.value.toFixed(1).substr(-1) == '0' ? data.data.value : data.data.value.toFixed(1)} % ` : ''
                                }
                                */
                          w.sunOptions = sunOptions
                          fileInputElement.value = ''
                          w.activeNames = ['1', '2', '3']
                          w.spinner = false
                      } catch (err) {
                          w.$modal.show('dialog', {
                              title: 'Error',
                              text: err,
                              clickToClose: true,
                              class: 'warning'
                          })
                          fileInputElement.value = ''
                          console.log(err)
                          w.spinner = false;
                      }
                  };
                  reader.readAsText(files[0]);
              }
          },
          readFTDNAFile(event) {
              let w = this;
              let csv = event.target.result.split('\r\n').filter(x => x != '')
              csv = csv.map(x => x.split(','))
              csv = csv.map(x => x.map(y => y.replace(/"/g, '').replace(/\\r/, '')))
              let keys = csv[0]
              if (!keys || !(keys[0] == "Full Name" && keys[5] == "Relationship Range")) {
                  w.$modal.show('dialog', {
                      title: 'Error',
                      text: "This does not appear to be a valid FTDNA Relatives file",
                      clickToClose: true,
                      class: 'warning'
                  })
                  w.spinner = false
                  return;
              }
              csv.shift()
              let all = []
              let haplos = []
              let paternal = []
              let countries = []
              let found = {}
              let found2 = {}
              let found3 = {}
              let surnames = []
              csv.map(x => {
                  let obj = {};
                  keys.map((y, i) => {
                      obj[y] = x[i]
                  });
                  all.push(obj)
              })
              all.map(x => {
                  if (!found[x['Full Name']] && (all.findIndex(y => y['Full Name'] == x['Full Name'] && y[
                          'Y-DNA Haplogroup'] != '') >= 0)) {
                      let group = all[all.findIndex(y => y['Full Name'] == x['Full Name'] && y[
                          'Y-DNA Haplogroup'] != '')][
                          'Y-DNA Haplogroup'
                      ]
                      haplos.push({
                          group: group.split('-')[0],
                          subgroup: group.split('-')[1]
                      })
                      found[x['Full Name']] = true
                  }
                  if (!found2[x['Full Name']] && (all.findIndex(y => y['Full Name'] == x['Full Name']) >= 0)) {
                      let group = all[all.findIndex(y => y['Full Name'] == x['Full Name'])][
                          'Ancestral Surnames'
                      ]
                      if (group) {
                          group = group.split(' ');
                          group = group[group.length - 1]
                          paternal.push({
                              name: x['Full Name'],
                              surname: group
                          });
                      }
                      let lastname = x["Last Name"].trim().split(' ')
                      lastname = lastname[lastname.length - 1]
                      if (lastname && lastname != group) {
                          paternal.push({
                              name: x['Full Name'],
                              surname: lastname
                          });
                      }
                      found2[x['Full Name']] = true
                  }
              });
              paternal.map(x => {
                  if (x.surname.length > 1) {
                      let index = surnames.findIndex(y => y.surname == x.surname);
                      if (index < 0) {
                          surnames.push({
                              surname: x.surname,
                              count: 1
                          })
                      } else {
                          surnames[index].count = surnames[index].count + 1
                      }
                  }
              })
              surnames.sort((a, b) => a.surname > b.surname ? 1 : a.surname < b.surname ? -1 : 0)
              surnames.sort((a, b) => a.count > b.count ? -1 : a.count < b.count ? 1 : 0)

              let total = haplos.length
              let data = []
              let haploObj = {}
              haplos.map(x => {
                  haploObj[x.group] = haploObj[x.group] ? haploObj[x.group] + (100 / total) : 100 / total
              });
              Object.keys(haploObj).map(x => {
                  let child = {
                      name: x,
                      value: haploObj[x],
                      children: []
                  }
                  let subgroups = haplos.filter(y => y.group == x)
                  let subtotal = subgroups.length
                  let value = child.value
                  let childObj = {}
                  subgroups.map(z => {
                      childObj[z.subgroup] = childObj[z.subgroup] ? childObj[z.subgroup] + value /
                          subtotal : value /
                          subtotal
                  })
                  Object.keys(childObj).map(c => {
                      let grandchild = {
                          name: c,
                          value: childObj[c],
                          children: []
                      }
                      child.children.push(grandchild)
                  })
                  data.push(child);
              })
              return ([data, surnames, []])
          },
          read23andMeFile(event) {
              let csv = event.target.result.split('\n').filter(x => x != '')
              csv = csv.map(x => x.split('","'))
              csv = csv.map(x => x.map(y => y.replace(/"/g, '').replace(/\\r/, '')))
              let keys = csv[0]
              if (!keys || keys[0] != "Display Name") {
                  w.$modal.show('dialog', {
                      title: 'Error',
                      text: "This does not appear to be a valid DNA Relatives file",
                      clickToClose: true,
                      class: 'warning'
                  })
                  w.spinner = false
                  return;
              }
              csv.shift()
              let all = []
              let haplos = []
              let paternal = []
              let countries = []
              let found = {}
              let found2 = {}
              let found3 = {}
              let surnames = []
              csv.map(x => {
                  let obj = {};
                  keys.map((y, i) => {
                      obj[y] = x[i]
                  });
                  all.push(obj)
              })
              all.map(x => {
                  if (!found[x['Display Name']] && (all.findIndex(y => y['Display Name'] == x['Display Name'] &&
                          y[
                              'Paternal Haplogroup'] != '') >= 0)) {
                      let group = all[all.findIndex(y => y['Display Name'] == x['Display Name'] && y[
                              'Paternal Haplogroup'] !=
                          '')]['Paternal Haplogroup']
                      haplos.push({
                          group: group.split('-')[0],
                          subgroup: group.split('-')[1]
                      })
                      found[x['Display Name']] = true
                  }
                  if (!found2[x['Display Name']] && (all.findIndex(y => y['Display Name'] == x[
                          'Display Name']) >= 0)) {
                      let group = all[all.findIndex(y => y['Display Name'] == x['Display Name'])][
                          'Family Surnames'
                      ]
                      if (group) {
                          let groups = group.split(',')
                          groups = groups.map(x => x.trim()[0].split(' ')[0].toUpperCase() + x.trim().split(
                                  ' ')[0]
                              .toLowerCase().slice(1))
                          groups.map(group => {
                              if (paternal.findIndex(n => n.name == x['Display Name'] && n.surname ==
                                      group) < 0) {
                                  paternal.push({
                                      name: x['Display Name'],
                                      surname: group
                                  });
                              }
                          })
                      }
                      let lastname = x["Surname"].trim()
                      if (lastname && paternal.findIndex(n => n.name == x['Display Name'] && n.surname ==
                              lastname) < 0) {
                          paternal.push({
                              name: x['Display Name'],
                              surname: lastname
                          });
                      }
                      found2[x['Display Name']] = true
                  }
              });
              paternal.map(x => {
                  if (x.surname.length > 1) {
                      let index = surnames.findIndex(y => y.surname == x.surname);
                      if (index < 0) {
                          surnames.push({
                              surname: x.surname,
                              count: 1
                          })
                      } else {
                          surnames[index].count = surnames[index].count + 1
                      }
                  }
              })
              surnames.sort((a, b) => a.surname > b.surname ? 1 : a.surname < b.surname ? -1 : 0)
              surnames.sort((a, b) => a.count > b.count ? -1 : a.count < b.count ? 1 : 0)

              let include = ['Display Name', 'Maternal Grandmother Birth Country', 'Maternal Grandfather Birth Country',
                  'Paternal Grandmother Birth Country', 'Paternal Grandfather Birth Country'
              ]
              all.map(x => {
                  let obj = {};
                  keys.map((y, i) => {
                      if (include.indexOf(y) >= 0) {
                          obj[y] = x[i]
                      }
                  });
                  all.push(obj)
              })
              include.shift()
              all.map(x => {
                  if (!found3[x['Display Name']]) {
                      include.map(key => {
                          if (x[key]) {
                              let index = countries.findIndex(z => z.country == x[key])
                              if (index < 0) {
                                  countries.push({
                                      country: x[key],
                                      count: 1
                                  })
                              } else {
                                  countries[index].count = countries[index].count + 1
                              }
                          }
                      })
                      found3[x['Display Name']] = true
                  }
              });
              countries.sort((a, b) => a.country > b.country ? 1 : a.country < b.country ? -1 : 0)
              countries.sort((a, b) => a.count > b.count ? -1 : a.count < b.count ? 1 : 0)
              let total = haplos.length
              let data = []
              let haploObj = {}
              haplos.map(x => {
                  haploObj[x.group] = haploObj[x.group] ? haploObj[x.group] + (100 / total) : 100 / total
              });
              Object.keys(haploObj).map(x => {
                  let child = {
                      name: x,
                      value: haploObj[x],
                      children: []
                  }
                  let subgroups = haplos.filter(y => y.group == x)
                  let subtotal = subgroups.length
                  let value = child.value
                  let childObj = {}
                  subgroups.map(z => {
                      childObj[z.subgroup] = childObj[z.subgroup] ? childObj[z.subgroup] + value /
                          subtotal : value /
                          subtotal
                  })
                  Object.keys(childObj).map(c => {
                      let grandchild = {
                          name: c,
                          value: childObj[c],
                          children: []
                      }
                      child.children.push(grandchild)
                  })
                  data.push(child);
              })
              return ([data, surnames, countries])
          },
          closeDrawer(evt) {
              this.$store.commit('change', {
                  spinner: false
              })
              this.$emit('closed')
          },
          share: function(obj) {
              let w = this;
              let functions = {
                  facebook: function(params) {
                      let path = params.path
                      let theme = params.theme
                      w.shareUrl = {
                          social: 'facebook',
                          shareQuote: 'my Genoplot Admixture Calculator results',
                          shareUrl: 'https://genoplot.com/shared/admix/?share=' + path + '#' + theme,
                          shareDesc: "Genetic Ancestry Modeling",
                          shareTitle: "Genoplot Admix results"
                      }
                  },
                  twitter: function(params) {
                      let shareHash = 'genoplot,genetics,geneology,ancestry,admixture'
                      let path = params.path
                      let theme = params.theme
                      w.shareUrl = {
                          social: 'twitter',
                          shareHash: shareHash,
                          shareVia: 'genoplot',
                          shareText: 'my Genoplot Admixture Calculator results',
                          shareUrl: 'https://genoplot.com/shared/admix/?share=' + path + '#' + theme
                      }
                  },
                  reddit: function(params) {
                      let shareHash = 'genoplot,genetics,ancestry,admixture,calculator' + w.components.map(
                          x => x.replace(
                              / ► /g, '_').replace(/ /g, '')).join(',')
                      let path = params.path
                      let theme = params.theme
                      w.shareUrl = {
                          social: 'reddit',
                          shareHash: shareHash,
                          shareVia: 'genoplot',
                          shareText: 'my Genoplot Admixture calculator results',
                          shareUrl: 'https://genoplot.com/shared/admix/?share=' + path + '#' + theme
                      }
                  }
              }
              functions[obj.name](obj.params)
          },
          saveShare: function(params) {
              let w = this;
              w.createNew = true;
              params = params || 'save'
              if (w.plotId !== w.lastShared || !w.currentShare) {
                  if (w.activePath) {
                      let buttons = [{
                              title: 'Update',
                              handler: () => {
                                  w.createNew = false;
                                  saveShare();
                                  w.$modal.hide('dialog');
                              } // Button click handler
                          },
                          {
                              title: 'Create New',
                              handler: () => {
                                  w.createNew = true;
                                  saveShare();
                                  w.$modal.hide('dialog');
                              } // Button click handler
                          },
                          {
                              title: 'Cancel',
                              default: true,
                              handler: () => {
                                  w.closable = false;
                                  w.$modal.hide('dialog');
                              } // Button click handler
                          }
                      ]
                      this.$modal.show('dialog', {
                          title: 'Update or Create New?',
                          text: 'Do you want to save to existing Chart<br/>or save as a new Chart?',
                          class: undefined,
                          buttons: buttons
                      })
                  } else {
                      saveShare()
                  }

                  function saveShare() {
                      console.log(w.calcArray[0].calculator, w.calcArray[0].label);
                      let calc = w.calcArray[0].calculator
                      let payload = {
                          date: Date.now(),
                          version: w.calcArray[0] && w.calcArray[0].v ? w.calcArray[0].v : 0,
                          user: w.user.username,
                          json: w.chartJSON,
                          markers: w.lastMarkerState ? true : false,
                          markerState: w.lastMarkerState,
                          shareType: params,
                          sort: !w.lastSort ? true : false,
                          index: w.currentIndex,
                          key: w.chartKey,
                          mode: w.G25calc ? 'G25' : undefined,
                          categories: w.categories,
                          components: w.components,
                          colors: w.$store.getters.get('rawchartColors'),
                          //calcComponents: w.calcComponents &&  w.calcComponents.length > 0 ? w.calcComponents : undefined,
                          calculator: w.calcArray[0] && w.calcArray[0].calculator && w.calcArray[0].owner ? w
                              .calcArray[0]
                              .owner + ':' + calc : undefined,
                          calcArray: w.calcArray.map(x => x.index ? x.index : x.label),
                          sliders: {
                              colors: (w.slider.colors.value - 1) % 5,
                              batches: w.slider.batches.value,
                              cycles: w.slider.cycles.value,
                          },
                          switches: {
                              scaled: w.switches.scaled,
                              penalty: w.switches.penalty,
                              groupAveraged: w.switches.groupAveraged,
                              ancient: w.switches.ancient || false,
                              groupMedian: w.switches.groupMedian,
                              removeOutliers: w.switches.removeOutliers,
                              calculator: w.calculator
                          },
                          primaryTab: w.primaryT === "" ? "chart" : w.primaryT,
                          secondaryTab: w.secondaryT === "" ? "table" : w.secondaryT
                      }
                      if (w.alias && !(w.activeName && !w.createNew) || w.alias && !w.createNew && w.activePath && w
                          .activePath
                          .split('/')[0] == w.alias) {
                          payload.alias = w.alias;
                      }
                      let defaultName = w.activeName && !w.createNew ? w.activeName : (payload.categories && payload
                          .categories[
                              0] ? (payload.categories[0].split(':').length > 1 ? payload.categories[0].split(
                              ':')[1].split('@')[
                              0] : payload.categories[0].split(' ').reverse()[0]).split('@')[0] : '') + (payload
                          .components ? '| ' +
                          payload.components.join(', ').replace(/_/g, ' ') : '')
                      let postContent = w.activeContent && !w.createNew ? w.activeContent : undefined
                      if (w.subType > 0) {
                          let buttons = [{
                                  title: 'OK',
                                  handler: () => {
                                      try {
                                          let input = document.getElementById('saveDialog')
                                          defaultName = input.textContent || defaultName
                                          w.activeName = w.createNew ? false : defaultName
                                          w.activeContent = w.createNew ? undefined : postContent
                                          let post = document.getElementById('shared-description')
                                          postContent = post.value || undefined
                                          if (!defaultName || (defaultName && defaultName.length < 60)) {
                                              w.$modal.show('dialog', {
                                                  title: 'Title is too short',
                                                  text: 'Please set a longer title. Titles need to be at least 60 characters long. You are short by ' +
                                                      (60 - defaultName.length) + ' characters',
                                              })
                                          } else {
                                              save()
                                              w.$modal.hide('saveDialog');
                                          }
                                      } catch (err) {
                                          w.$modal.show('dialog', {
                                              class: 'warning',
                                              title: 'Error',
                                              text: err
                                          })
                                          console.log(err);
                                      }
                                  } // Button click handler
                              },
                              {
                                  title: 'Cancel',
                                  default: true,
                                  handler: () => {
                                      w.closable = false;
                                      w.$modal.hide('customDialog');
                                  } // Button click handler
                              }
                          ]
                          if (w.createNew || !w.createNew) {
                              w.$modal.show('saveDialog', {
                                  payload: {
                                      ...payload,
                                      ...{
                                          name: defaultName,
                                          type: 'admix',
                                          content: postContent
                                      }
                                  },
                                  buttons: buttons
                              })
                              setTimeout(() => {
                                  let input = document.getElementById('saveDialog');
                                  if (input && w.createNew) {
                                      input.focus();
                                      w.selectElementContents(input)
                                  }
                              }, 100)
                          } else {
                              save()
                          }
                      } else {
                          save()
                      }
                      async function save() {
                          let name = w.alias ? w.alias : w.user.username;
                          //let path = !w.createNew && w.activePath ? w.user.username + '/' + w.activePath.split('/')[1] : `${w.user.username}/${Date.now().toString(16)}`
                          let path = !w.createNew && w.activePath ? w.user.username + '/' + w.activePath.split(
                                  '/')[1] :
                              `${name}/${Date.now().toString(16)}`
                          payload.name = defaultName
                          if (w.subType > 0) {
                              w.activePath = path;
                              w.activeName = defaultName;
                          }
                          path = path;
                          let theme = w.theme ? 2 : 1
                          let type = 'admix'
                          payload.path = path
                          if (postContent) payload.content = postContent
                          if (w.topics && w.topics[path] && !w.createNew) payload.published = w.topics[path]
                          payload.theme = theme
                          payload.type = type
                          let contentType = 'application/json'
                          w.spinner = true
                          let sigparams = {
                              filePath: path,
                              fileType: type,
                              shareType: payload.shareType,
                              email: w.user.email,
                              username: w.user.username,
                              contentType: contentType,
                              jsonPayload: payload
                          }
                          if (w.env && typeof(w.env) == 'string' && (w.env == 'development' || w.env ==
                                  'staging')) {
                              sigparams.debug = true
                              sigparams.env = 'dev'
                          }
                          let data = await w.$apollo.query({
                              query: getS3SignatureQuery,
                              variables: {
                                  params: JSON.stringify(sigparams)
                              },
                              fetchPolicy: 'network-only'
                          })
                          if (data && data.data && data.data.gets3Signature && data.data.gets3Signature
                              .result) {
                              let result = JSON.parse(data.data.gets3Signature.result);
                              if (result.url && !result.uploaded) {
                                  let signedUrl = result.url;
                                  let options = {
                                      headers: {
                                          'Content-Type': contentType,
                                          'Content-Encoding': 'gzip'
                                      }
                                  }
                                  axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(JSON.stringify(
                                          payload))), options)
                                      .then(function(result) {
                                          w.spinner = false
                                          w.currentShare = {
                                              params: params,
                                              theme: theme,
                                              path: path
                                          }
                                          w.lastShared = w.plotId
                                          showShare(params, path, theme)
                                      })
                                      .catch(function(err) {
                                          w.spinner = false
                                          console.log(err);
                                          w.$eventBus.$emit('appEvents', {
                                              exec: 'show',
                                              component: 'nav',
                                              params: {
                                                  title: "Error",
                                                  text: "unable to save model",
                                                  class: 'warning'
                                              }
                                          })
                                      });
                              } else if (result.uploaded) {
                                  w.spinner = false
                                  w.currentShare = {
                                      params: params,
                                      theme: theme,
                                      path: path
                                  }
                                  w.lastShared = w.plotId
                                  showShare(params, path, theme)
                              } else {
                                  w.spinner = false
                                  console.log(result);
                                  w.$eventBus.$emit('appEvents', {
                                      exec: 'show',
                                      component: 'nav',
                                      params: {
                                          title: "Error",
                                          text: "unable to save model",
                                          class: 'warning'
                                      }
                                  })

                              }
                          } else {
                              w.spinner = false
                              console.log(data);
                              w.$eventBus.$emit('appEvents', {
                                  exec: 'show',
                                  component: 'nav',
                                  params: {
                                      title: "Error",
                                      text: "unable to save model",
                                      class: 'warning'
                                  }
                              })
                          }
                      }
                  }
              } else {
                  showShare(params, w.currentShare.path, w.currentShare.theme)
              }

              function showShare(params, path, theme) {
                  if (params === 'save') {
                      let url = 'https://genoplot.com/shared/admix/?share=' + path + '#' + theme
                      let buttons = [{
                          title: "Copy URL",
                          handler: (i, event) => {
                              copy(url)
                              document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                          }
                      }, {
                          title: '<a href="mailto:?subject=my Genoplot PCA&body=' + url + '" >Email</a>'
                      }, {
                          title: 'Close',
                          default: true
                      }]
                      w.$modal.show('dialog', {
                          title: 'Share',
                          text: "You can now share this PCA from this <a target='_blank' href='https://genoplot.com/shared/admix/?share=" +
                              path + "#" + theme + "'>link</a>",
                          buttons: buttons,
                          clickToClose: false,
                          class: 'alert',
                          beforeClosed: function(event) {
                              console.log('closing', event)
                          }
                      })
                  } else {
                      w.share({
                          name: params,
                          params: {
                              theme: theme,
                              path: path
                          }
                      })
                  }
              }
          },
      },
      computed: {
          ...mapState({
              onLine: 'onLine',
              geo: 'geo',
              alias: 'alias',
              slider: 'slider',
              credits: 'credits',
              isAdmin: 'isAdmin',
              proxyUser: 'proxyUser',
              subs: 'subscription',
              themes: 'themes',
          }),
          running: {
              get() {
                  return this.$store.getters.get('spinner')
              },
              set(value) {
                  this.$store.commit('change', {
                      spinner: value
                  })
              }
          },
          primaryTabs: {
              get() {
                  return this.$store.getters.get('labsPrimaryTab') || 'maps'
              },
              set(value) {
                  this.$store.commit('change', {
                      labsPrimaryTab: value
                  })
              }
          },
          agtheme: function() {
              return this.theme ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'
          },
          saveReady: function() {
              if (this.series && this.series.length > 0) {
                  return true
              } else {
                  return false
              }
          },
          isMobile: function() {
              return this.$isMobile ? true : false;
          },
          isPhone: function() {
              let ios = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
                  navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
              let mobile = navigator.userAgentData && navigator.userAgentData.mobile ? true : false
              return (ios || mobile) ? true : false
          },
          user() {
              return this.$store.getters.get('user')
          },
          alias() {
              return this.$store.getters.get('alias')
          },
          spinner: {
              get() {
                  return this.$store.getters.get('spinner')
              },
              set(value) {
                  this.$store.commit('change', {
                      spinner: value
                  })
              }
          },
          show: {
              get() {
                  if (this.showlab) {}
                  return this.showlab
              },
              set(value) {
                  this.$emit('show', value)
              }
          },
          haplos() {
              let haplos = []
              if (this.sunOptions.series.data.length == 0) {
                  return []
              } else {
                  haplos = this.sunOptions.series.data.sort((a, b) => a.value > b.value ? -1 : a.value > b.value ? 1 :
                      0).map(
                      x => {
                          return {
                              name: x.name,
                              value: x.value
                          }
                      })
                  return haplos
              }
          },
          columnDefs2: function() {
              let w = this;
              var columns = [{
                  maxWidth: 280,
                  headerName: 'COUNTRY',
                  field: 'country',
                  sortable: true,
                  resizable: true,
                  rowDrag: false,
                  headerClass: 'header-sample',
                  cellClass: 'cell-sample',
                  filter: true,
                  tooltipField: 'country',
                  cellStyle: {
                      textTransform: 'uppercase',
                      borderBottom: 'none',
                      textAlign: 'left',
                      paddingRight: '22px',
                      fontSize: '10px'
                  },
              }, {
                  headerName: 'COUNT',
                  field: 'count',
                  sortable: true,
                  rowDrag: false,
                  resizable: true,
                  headerClass: 'header-fit',
                  cellStyle: {
                      fontWeight: 700,
                  },
                  filter: false,
                  cellClass: 'count'
              }]
              return columns;
          },
          columnDefs: function() {
              let w = this;
              var columns = [{
                  headerName: 'LAST NAME',
                  field: 'name',
                  filter: true,
                  sortable: true,
                  resizable: true,
                  rowDrag: false,
                  headerClass: 'header-sample',
                  cellClass: 'cell-sample',
                  maxWidth: 280,
                  tooltipField: 'name',
                  cellStyle: {
                      textTransform: 'uppercase',
                      borderBottom: 'none',
                      textAlign: 'left',
                      paddingRight: '22px',
                      fontSize: '10px'
                  },
              }, {
                  headerName: 'COUNT',
                  field: 'count',
                  sortable: true,
                  rowDrag: false,
                  resizable: true,
                  headerClass: 'header-fit',
                  cellStyle: {
                      fontWeight: 700,
                  },
                  filter: false,
                  cellClass: 'count'
              }]
              return columns;
          },
          rowData: function() {
              var w = this;
              if (this.namedata && Array.isArray(this.namedata)) {
                  var json = JSON.parse(JSON.stringify(this.namedata))
                  var rows = [];
                  json.forEach(function(p, i) {
                      var obj = {};
                      obj.name = p.surname
                      obj.count = p.count
                      rows.push(obj)
                  })
                  return rows;
              } else {
                  return []
              }
          },
          rowData2: function() {
              var w = this;
              if (this.countrydata && Array.isArray(this.countrydata)) {
                  var json = JSON.parse(JSON.stringify(this.countrydata))
                  var rows = [];
                  json.forEach(function(p, i) {
                      var obj = {};
                      obj.country = countries[p.country] ? countries[p.country] : p.country
                      obj.count = p.count
                      rows.push(obj)
                  })
                  return rows;
              } else {
                  return []
              }
          },
      },
      components: {
          [Button.name]: Button,
          'v-chart': () => import('vue-echarts'),
          AgGridVue,
          //AgGridVue: () => import("ag-grid-vue").AgGridVue,
          [Collapse.name]: Collapse,
          [CollapseItem.name]: CollapseItem,
          Social,
          Selections
      }
  }
</script>
<style>
  body.labs #GenoLabs .el-drawer__header {
    padding: 0;
    margin: 0;
  }

  body.labs #GenoLabs .el-drawer__close-btn {
    top: 10px;
    right: 10px;
  }

  body.labs #GenoLabs .el-drawer__body.labs {
    padding: 15px 50px 50px 50px;
  }

  body.labs #GenoLabs #header {
    position: relative;
    width: 100%;
    height: 60px;
    font-size: 2em;
    font-weight: 700;
    color: #3c688f;
    padding-left: 0px;
    margin-top: 0px;
  }

  body.labs #GenoLabs #header,
  body.nmonte-container #GenoLabs #header * {
    cursor: default;
  }

  body.labs #GenoLabs .el-tabs--border-card {
    border: none;
  }

  body.labs #GenoLabs #header #statusLogo .logo {
    position: absolute;
    ;
    top: -16px;
    left: 2px;
    background: transparent;
  }

  body.labs #GenoLabs #header #statusLogo .logo svg {
    width: 64px;
    height: 64px;
    fill: black;
  }

  body.labs #GenoLabs #header #statusLogo .logo svg circle {
    fill: #f2f2f2;
  }

  body.labs #GenoLabs #header #statusLogo .logo svg path {
    fill: #d83904e3;
  }

  body.labs #GenoLabs sub.header {
    font-size: 0.5em;
    opacity: 0.3;
    color: black;
    text-transform: lowercase;
    font-weight: 700;
    left: -3.6em;
    margin-left: 50px;
    top: -1.8em;
  }

  body.labs #GenoLabs .nav-tabs {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    max-width: 540px;
  }

  body.labs #GenoLabs li a.nav-link {
    pointer-events: none;
    cursor: not-allowed;
  }

  body.labs #GenoLabs li a.nav-link.active {
    pointer-events: all;
    cursor: pointer;
  }

  body.labs #GenoLabs .el-tabs.el-tabs--top {
    margin-top: 0px;
  }

  body.labs #GenoLabs .results {
    height: 100%;
  }

  body.labs #GenoLabs .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: #3c688f;
    font-weight: 700;
  }

  body.labs #GenoLabs .el-tabs--border-card>.el-tabs__content {
    padding: 30px;
  }

  body.labs #GenoLabs .el-tabs--border-card>.el-tabs__content label.feature {
    text-transform: uppercase;
    font-size: 1em;
    margin-right: 20px;
    font-weight: 600;
    opacity: 0.7;
    width: unset;
    margin-left: unset;
  }

  body.labs #GenoLabs .el-tabs--border-card>.el-tabs__content button.feature {
    text-transform: uppercase;
    font-weight: 600;
    margin-top: 3px;
    color: white;
    background-color: #2e668c;
  }

  body.labs #GenoLabs.el-drawer__wrapper.labs .el-drawer.rtl {
    right: unset;
    width: 100% !important;
  }

  body.labs #GenoLabs label.btn-info {
    background-color: #2e668c;
  }

  body.labs #GenoLabs label.btn-info:hover {
    background-color: #2e668cbb;
  }

  body.labs #GenoLabs .el-tabs__content .el-collapse {
    margin-top: 50px;
  }

  body.labs #GenoLabs .el-tabs__content .el-collapse-item__header {
    text-transform: uppercase;
    font-weight: 600;
    color: #2e668c;
    opacity: 0.7;
  }

  body.labs #GenoLabs .el-tabs__content .el-collapse-item .header-icon {
    margin-left: 5px;
    color: #2e668c;
    opacity: 0.7;
  }


  #GenoLabs #maplegend-wrapper #maplegend .series-color {
    cursor: default;
    display: inline-block;
    float: right;
    position: relative;
    width: 12px;
    margin-right: 19px;
    top: 5px;
    height: 12px;
    border-radius: 10px;
    transition: background-color 0.5s;
  }

  #GenoLabs #maplegend {
    margin-top: 0px;
    top: -4px;
    padding-bottom: 10px;
  }

  #GenoLabs #maplegend-wrapper #maplegend .series-value {
    cursor: default;
    display: inline-block;
    text-align: right;
    float: right;
    margin-top: 4px;
    margin-right: 15px;
    font-weight: 700;
    font-size: 10px;
    width: 35px;
  }

  #GenoLabs #maplegend-wrapper #maplegend .series {
    cursor: default;
    margin-right: 12px;
    font-size: 10px;
    display: inline-block;
    width: 152px;
    padding-left: 10px;
    text-align: right;
  }


  #GenoLabs .echarts {
    width: 100%;
    height: 500px;
    margin-left: -100px;
    margin-top: -25px;
  }

  body.labs #GenoLabs #sunburst-wrapper {
    height: 492px;
    position: relative;
    flex: 2;
    min-width: 600px;
  }

  body.labs #GenoLabs .chart {
    width: 100%;
    height: 100%;
  }


  body.labs #GenoLabs #maplegend-wrapper #maplegend {
    min-width: 250px;
    position: relative;
    left: -60px;
  }

  body.labs #GenoLabs #maplegend-wrapper span.haplo {
    width: 100px;
    text-align: right;
    display: inline-block;
  }

  body.labs #GenoLabs #maplegend-wrapper span.name {
    width: 10px;
    text-align: right;
    display: inline-block;
  }

  body.labs #GenoLabs #sunburst-wrapper.chartwrapper .labprofile {
    position: absolute;
    text-align: center;
    border-radius: 50px;
    z-index: 1;
    width: 72px;
    height: 72px;
    left: 50%;
    top: 52.5%;
    box-shadow: -7px 7px 16px -6px #00000052;
    margin-left: -135px;
    margin-top: -69px;
    background: #c23531;
    background: #79b0e6;
  }

  body.labs #page-overlay.spinner {
    z-index: 9999999;
  }

  body.labs #GenoLabs #haplopane .chart {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
  }

  #GenoLabs #andMeHelp {
    z-index: 11;
    width: 36px;
    height: 36px;
    opacity: 0.8;
    border-radius: 40px;
    border: 4px solid;
    cursor: pointer;
    position: absolute;
    font-size: 20px;
    font-weight: 700;
    margin-left: -2px;
    text-align: center;
    margin-top: 13px;
    line-height: 30px;
    background: white;
    color: #d83904e3;
    -webkit-transition: opacity 0.5s, color 0.5s;
    transition: opacity 0.5s, color 0.5s;
  }

  #GenoLabs .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-disabled {
    opacity: 0.5;
  }

  #GenoLabs section.labs {
    margin-top: 64px;
  }

  body.dark.labs #GenoLabs .el-drawer__body,
  body.dark.labs #GenoLabs section {
    background: #181818;
  }

  body.dark.labs #GenoLabs .el-collapse-item>div,
  body.dark.labs #GenoLabs .el-tabs,
  body.dark.labs #GenoLabs .el-collapse-item__header,
  body.dark.labs #GenoLabs .el-collapse-item__content .chart {
    background: #181818;
    color: #79b0e6;
    opacity: 1;
  }

  body.dark.labs #GenoLabs .el-tabs--border-card>.el-tabs__content label.feature {
    opacity: 1;
  }

  body.labs #GenoLabs .el-tabs--border-card>.el-tabs__content label.btn.feature {
    opacity: 0.8;
    transition: opacity 0.2s;
    line-height: 18px;
    padding: 10px 15px 12px 15px;
    transition: opacity 0.2s;
    margin-left: 20px;
    margin-right: 30px;
    -webkit-transition: opacity 0.2s;
  }

  body.dark.labs #GenoLabs .el-tabs--border-card>.el-tabs__content label.btn.feature {
    background: #ca580a;
    border: 1px solid #ffa5006e;
  }

  body.labs #GenoLabs .el-tabs--border-card>.el-tabs__content label.btn.feature:hover {
    opacity: 1;
  }

  body.dark.labs #GenoLabs #header {
    color: white;
  }

  body.labs #GenoLabs sub.header {
    margin-left: 50px;
    top: 0em;
  }

  body.labs #GenoLabs .features.labs #maplegend-wrapper {
    border: none;
  }
#GenoLabs .features.labs  #maplegend-wrapper {
    position: absolute;
    left: 85px;
    top: 0;
    color: #6f6f6f;
    padding: 0px 0px;
    border-radius: 5px;
    border: 2px solid #ffffff22;
    font-family: "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    background: none;
}
body #GenoLabs .features.labs  #maplegend-wrapper {
position: relative;
flex: 1;
left: 0;
max-width: 250px;
min-width: 250px;
}

  body.dark.labs #GenoLabs #maplegend-wrapper #maplegend {
    color: silver;
  }

  body.dark.labs #GenoLabs .el-collapse {
    border-top: 1px solid transparent;
  }

  body.dark.labs #GenoLabs .el-collapse-item__wrap {
    border-bottom: 1px solid transparent;
  }

  body.dark.labs .el-collapse-item {
    border-top: 1px solid #ebeef522;
    border-bottom: 1px solid #ebeef522;
  }

  body.dark.labs #GenoLabs .el-tabs__content .el-collapse-item .header-icon {
    color: white;
    opacity: 1;
    margin-left: 10px;
  }

  body.dark.labs #GenoLabs .el-tabs--border-card>.el-tabs__header .el-tabs__item {
    text-align: center;
    font-weight: 700;
    color: white;
    font-size: 1.2em;
    border-bottom: 1px solid transparent;
    opacity: 0.8;
  }

  body.dark.labs #GenoLabs .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: #79b0e6;
    background: #181818;
    border: 0px solid #181818;
    border-bottom: 1px solid silver;
    margin-left: unset;
    opacity: 1;
  }

  body.dark.labs .el-tabs__nav-scroll {
    overflow: hidden;
    background: #181818;
  }

  body.dark .el-collapse-item__header,
  body.dark.labs .el-collapse {
    border-bottom: none;
  }

  body.labs #GenoLabs sub.header {
    margin-left: 58px;
    top: 0em;
    color: gray;
    opacity: 1;
  }

  body.labs .tooltip.noarrow .tooltip-arrow {
    display: none;
  }

  body.dark #GenoLabs .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-disabled {
    opacity: 0.2;
  }

  #GenoLabs #tab-23andMe {
    width: 110px;
  }

  #GenoLabs #tab-FTDNA {
    width: 100px;
  }

  #GenoLabs #tab-maps {
    width: 150px;
  }

@media only screen and (max-width: 768px) {
body.isMobile #GenoLabs  #tab-maps, body.isMobile #GenoLabs  #tab-23andMe, body.isMobile #GenoLabs  #tab-FTDNA, body.isMobile #GenoLabs  #tab-3, body.isMobile #GenoLabs  #tab-4 {
display: none;
}
body.isMobile #GenoLabs #header sub {
display: none;
}
body.labs.isMobile #GenoLabs .el-drawer__body.labs {
padding: 20px 0px;
}
body.labs.isMobile #GenoLabs .el-tabs--border-card.maps>.el-tabs__content {
padding: 10px;
}
body.labs.isMobile #GenoLabs #header {
padding: 0px 30px;
}
body.labs.isMobile #GenoLabs #headingOne {
left: 10px
}
body.labs.isMobile #mainmap .heatmap {
height: calc(100% + 20px);
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: center;
    justify-content: flex-start;
padding: 0px 40px;
}
body.isMobile.labs #mainmap #heatchartWrapper {
width: 100vw;
max-width: 460px;
}
body.labs.isMobile #GenoLabs .heatmap.col-12 .el-table.maporacles {
margin: auto;
padding: 0 20px;
margin-top: -25px;
}
body.labs.isMobile #app #GenoLabs.absolute .container.g25 {
margin-top: 20px;
width: 100vw;
margin-bottom: -40px
}
body.labs.isMobile #app #genoSelect.nmonte .rightSelect {
margin-bottom: 40px;
}
body.labs.isMobile #mainmap .heatmap-label {
    margin-bottom: -80px;
    margin-top: -25px;
    height: 80px
}
body.labs.isMobile .el-table.maporacles table {
width: unset;
}
body.labs.isMobile #app #genoSelect .collapse-title {
position: absolute;
margin-top: -2px;
left: 20px;
}
body.labs.isMobile #app #genoSelect a.nav-link.btn.btn-primary {
    left: 144px;
    top: -1px;
}
body.labs.isMobile #app #genoSelect .card-collapse .card .card-header:after {
display: none;
}
body.labs.isMobile #genoSelect .label.province {
left: 18px;
top: 64px;
}
body.labs.isMobile #app #GenoLabs.absolute #genoSelect .section #result.nmonte {
top: -72px;
}
body.isMobile.labs #app #genoSelect #selectWrapper .multiselect__tags {
min-width: calc(100vw - 50px);
    max-width: 400px;
}
body.isMobile.labs #app #genoSelect #selectWrapper .multiselect {
min-width: calc(100vw - 55px);
    max-width: 300px;
}
body.dark.isMobile.labs #app #genoSelect #selectWrapper .multiselect__tags {
background: black;
}
body.labs.isMobile #app #GenoLabs.absolute #genoSelect .section.absolute {
position: relative;
top: 0px;
}
body.labs.isMobile #app #GenoLabs .card-plain .card-body, body.labs.isMobile  #GenoLabs.card-plain .card-header {
padding-top: 20px;
}
body.labs.isMobile #mainmap .pagination {
margin-top: -70px;
}
body.labs.isMobile #mainmap table.el-table__body .customsample .sample {
display: inline-block;
overflow-x: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
body.labs.isMobile #mainmap #mapscroller {
display: none;
}

}
@media only screen and (max-width: 365px) {
body.labs.isMobile #mainmap table.el-table__body .customsample .sample {
max-width: 156px;
}
}
@media only screen and (max-width: 400px) {
body.labs.isMobile #mainmap table.el-table__body .customsample .sample {
max-width: 200px;
}
}

</style>
